module.exports = "/_next/static/images/AnthonyRich-7fc51ab667af700ebcdccd6386d1eb58.webp";